{
  "alert": {
    "blurb": "Notification para makakuha ng attention ng user.",
    "name": "Alert"
  },
  "button": {
    "blurb": "Clickable na element na gumagawa ng action kapag na-press.",
    "default": "Default",
    "loading": "Naglo-load...",
    "name": "Button",
    "send": "I-send"
  },
  "components": {
    "name": "Mga Component",
    "title": "Mga Component"
  },
  "form": {
    "blurb": "Demo ng lahat ng input components na kasama sa template na ito.",
    "name": "Form",
    "title": "Form"
  },
  "orgName": "Mindsea Development",
  "title": "Component Sandbox"
}
